import React, { useEffect, useCallback, Fragment } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { isEmpty, isUndefined } from 'lodash';

import { useInjectReducer } from 'utils/injectReducer';
import { useInjectSaga } from 'utils/injectSaga';

import subscriptionPlansSaga from 'containers/SubscriptionPlans/saga';
import subscriptionPlansReducer from 'containers/SubscriptionPlans/reducer';
import { fetchSubscriptionPlans } from 'containers/SubscriptionPlans/actions';

import userReducer from './reducer';
import makeSelectUser from './selectors';
import userSaga from './saga';
import { fetchUser } from './actions';

function User(props) {
  useInjectReducer({ key: 'user', reducer: userReducer });
  useInjectSaga({ key: 'user', saga: userSaga });
  useInjectReducer({
    key: 'subscriptionPlans',
    reducer: subscriptionPlansReducer,
  });
  useInjectSaga({ key: 'subscriptionPlans', saga: subscriptionPlansSaga });

  const dispatch = useDispatch();
  const user = useSelector(makeSelectUser) || {};
  const redirectToLogin = useCallback(() => {
    window.location.assign(
      `/login/researcher?redirect_url=${window.location.pathname}${
        window.location.search
      }`,
    );
  }, []);

  const { userDetails, isFetching, hasFetched, hasFetchedWithError } = user;

  useEffect(() => {
    const shouldRedirectToLogin =
      isEmpty(userDetails) &&
      !isUndefined(isFetching) &&
      hasFetchedWithError === true &&
      !window.location.pathname.includes('login/researcher');

    if (shouldRedirectToLogin) {
      redirectToLogin();
    } else if (!userDetails && !isFetching && !hasFetched) {
      dispatch(fetchUser());
      dispatch(fetchSubscriptionPlans());
    }
  }, [dispatch, userDetails, isFetching, hasFetched]);

  if (!user.userDetails) {
    return null;
  }

  return <Fragment>{props.children}</Fragment>;
}

User.propTypes = {
  children: PropTypes.any,
};

export default User;
